import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide5: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Michael Jackson
            <br />
            They Don’t Care About Us
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=QNJL6nfu__Q"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Rico Dalasam</S.Name>
          <S.Profile>Rapper</S.Profile>
          <S.Text>
            “O primeiro clipe que me abalou foi ‘They don't care about us’, do
            Michael Jackson. Eu esperava a hora que o clipe ia passar. Dancei
            por meses! Eu já era louco pelo Michael desde os 4, 5 anos e, quando
            ele juntou sua música com o samba-reggae do Olodum, me deu uma
            sensação de pertencimento. Na minha casa, tinha uma blusa vermelha e
            preta que eu jurava que era igual à dele. Era só vestir que eu já
            começava a dançar.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
